import { createContext } from 'react';

const BarsContext = createContext({});

export default BarsContext;
